// https://zudello.gitbook.io/zudello-workflows/other/parameters
import moment from 'moment'
import {zParameterTypes} from '../../types/z/parameters'

export const appParams = Object.freeze({
    [zParameterTypes.TEXT]: {
        name: zParameterTypes.TEXT,
        type: String.name,
        typeInRules: String.name,
        label: 'Text'
    },
    [zParameterTypes.EMAIL]: {
        name: zParameterTypes.EMAIL,
        type: String.name,
        typeInRules: String.name,
        label: 'Email'
    },
    [zParameterTypes.NUMBER]: {
        name: zParameterTypes.NUMBER,
        type: Number.name,
        typeInRules: Number.name,
        label: 'Number'
    },
    [zParameterTypes.INTEGER]: {
        name: zParameterTypes.INTEGER,
        type: Number.name,
        typeInRules: Number.name,
        label: 'Integer'
    },
    [zParameterTypes.UINTEGER]: {
        name: zParameterTypes.UINTEGER,
        type: Number.name,
        typeInRules: Number.name,
        label: 'Uinteger'
    },
    [zParameterTypes.URL]: {
        name: zParameterTypes.URL,
        type: String.name,
        typeInRules: String.name,
        label: 'Url'
    },
    [zParameterTypes.ARRAY]: {
        name: zParameterTypes.ARRAY,
        type: Array.name,
        typeInRules: Array.name,
        label: 'Array'
    },
    [zParameterTypes.BOOLEAN]: {
        name: zParameterTypes.BOOLEAN,
        type: Boolean.name,
        typeInRules: Boolean.name,
        label: 'Boolean'
    },
    [zParameterTypes.BUFFER]: {
        name: zParameterTypes.BUFFER,
        type: undefined,
        typeInRules: undefined,
        label: 'Buffer'
    },
    [zParameterTypes.CERT]: {
        name: zParameterTypes.CERT,
        type: undefined,
        typeInRules: undefined,
        label: 'Certificate'
    },
    [zParameterTypes.COLLECTION]: {
        name: zParameterTypes.COLLECTION,
        type: Object.name,
        typeInRules: undefined,
        label: 'Collection'
    },
    [zParameterTypes.COLOR]: {
        name: zParameterTypes.COLOR,
        type: String.name,
        typeInRules: String.name,
        label: 'Color'
    },
    [zParameterTypes.DATE]: {
        name: zParameterTypes.DATE,
        type: Date.name,
        typeInRules: Date.name,
        label: 'Date'
    },
    [zParameterTypes.FILE]: {
        name: zParameterTypes.FILE,
        type: String.name,
        typeInRules: undefined,
        label: 'File'
    },
    [zParameterTypes.FOLDER]: {
        name: zParameterTypes.FOLDER,
        type: String.name,
        typeInRules: String.name,
        label: 'Folder'
    },
    [zParameterTypes.FILENAME]: {
        name: zParameterTypes.FILENAME,
        type: String.name,
        typeInRules: String.name,
        label: 'File name'
    },
    [zParameterTypes.FILTER]: {
        name: zParameterTypes.FILTER,
        type: Object.name,
        typeInRules: undefined,
        label: 'Filter'
    },
    [zParameterTypes.JSON]: {
        name: zParameterTypes.JSON,
        type: String.name,
        typeInRules: undefined,
        label: 'JSON'
    },
    [zParameterTypes.PATH]: {
        name: zParameterTypes.PATH,
        type: String.name,
        typeInRules: String.name,
        label: 'Path'
    },
    [zParameterTypes.PKEY]: {
        name: zParameterTypes.PKEY,
        type: String.name,
        typeInRules: String.name,
        label: 'Private key'
    },
    [zParameterTypes.PORT]: {
        name: zParameterTypes.PORT,
        type: Number.name,
        typeInRules: Number.name,
        label: 'Port'
    },
    [zParameterTypes.SELECT]: {
        name: zParameterTypes.SELECT,
        type: String.name,
        typeInRules: String.name,
        label: 'Select'
    },
    [zParameterTypes.TIME]: {
        name: zParameterTypes.TIME,
        type: String.name,
        typeInRules: String.name,
        label: 'Time'
    },
    [zParameterTypes.TIMEZONE]: {
        name: zParameterTypes.TIMEZONE,
        type: String.name,
        typeInRules: String.name,
        label: 'Timezone'
    },
    [zParameterTypes.TIMESTAMP]: {
        name: zParameterTypes.TIMESTAMP,
        type: String.name,
        typeInRules: String.name,
        label: 'Timestamp'
    },
    [zParameterTypes.UUID]: {
        name: zParameterTypes.UUID,
        type: String.name,
        typeInRules: String.name,
        label: 'UUID'
    },
    [zParameterTypes.PASSWORD]: { // hide for all selects?
        name: zParameterTypes.PASSWORD,
        type: String.name,
        typeInRules: String.name,
        label: 'Password'
    },
    [zParameterTypes.CONNECTION]: { // hide for all selects?
        name: zParameterTypes.CONNECTION,
        type: String.name,
        typeInRules: String.name,
        label: 'Connection'
    },
    [zParameterTypes.RPC]: { // hide for all selects?
        name: zParameterTypes.RPC,
        type: String.name,
        typeInRules: String.name,
        label: 'RPC'
    }
})

export const appParamsList = Object.freeze(Object.values(appParams))

export const predictAppParamTypeByValue = value => {
    if (typeof value === 'string') {
        if (
            /^#[0-9A-F]{6}$/i.test(value) ||
            /rgba?\((\d{1,3}), ?(\d{1,3}), ?(\d{1,3})\)?(?:, ?(\d(?:\.\d?))\))?/.test(value)) {
            return zParameterTypes.COLOR
        } else if (/\S+@\S+\.\S+/.test(value)) {
            return zParameterTypes.EMAIL
        } else if (/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g.test(value)) {
            return zParameterTypes.URL
        } else if (moment.tz.names().includes(value)) {
            return zParameterTypes.TIMEZONE
        } else if (/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(value)) {
            return zParameterTypes.UUID
        } else if (isNaN(value) && moment(value).isValid()) {
            return zParameterTypes.DATE
        }
        return zParameterTypes.TEXT
    } else if (typeof value === 'number') {
        if (Number.isInteger(value)) {
            return zParameterTypes.INTEGER
        }
        return zParameterTypes.NUMBER
    } else if (typeof value === 'object') {
        if (_.isArray(value)) {
            return zParameterTypes.ARRAY
        }
        return zParameterTypes.COLLECTION
    } else if (typeof value === 'boolean') {
        return zParameterTypes.BOOLEAN
    }
    return zParameterTypes.TEXT
}

export const checkIsExistingParamType = type => Object.keys(appParams).includes(type)
